import React, { useState, createContext, useContext } from 'react'
import { SelectedUserContext } from './selectedUserContext'
import { SelectedAddressContext } from './selectedAddressContext'

export const VariablesContext = createContext({} as any)

const VariablesContextProvider = (props: any) => {
  const [variables, setVariables] = useState<any>({
    pagination: { current: 1, pageSize: 10 },
  })
  const { selectedUser } = useContext(SelectedUserContext)
  const { selectedAddress } = useContext(SelectedAddressContext)

  const direction = (order: string | undefined) =>
    order === 'descend' ? 'desc' : 'asc'

  const apiParameters = () => ({
    pagination: {
      page: variables.pagination.current,
      pageLength: variables.pagination.pageSize,
    },
    sorter: variables.sorter?.order
      ? {
          field: variables.sorter.field,
          direction: direction(variables.sorter?.order),
        }
      : null,
    filters: variables.filters
      ? Object.entries(variables.filters)
          .map(item => (item[1] ? { field: item[0], values: item[1] } : null))
          .filter(n => n)
      : null,
    moderatorId: selectedUser,
    addressId: selectedAddress,
  })

  return (
    <VariablesContext.Provider
      value={{
        variables: variables,
        setVariables: setVariables,
        apiParameters: apiParameters,
      }}
    >
      {props.children}
    </VariablesContext.Provider>
  )
}

export default VariablesContextProvider
